import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'obpp-footer',
  templateUrl: './obpp-footer.component.html',
  styleUrls: ['./obpp-footer.component.scss']
})
export class OBPPFooterComponent implements OnInit {

  year = new Date().getFullYear().toString();

  constructor(public translate: TranslateService) { }

  ngOnInit() {
  }

  openCookiePreferences() {
    try {
      if (window.Osano && window.Osano.cm) {
        window.Osano.cm.showDrawer();
      } else {
        console.warn('Osano CMP not loaded yet.');
      }
    } catch (err) {
      console.error('Error opening Osano Preferences Drawer:', err);
    }
  }
}